import { List } from "@mui/material";
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useQuery } from "@tanstack/react-query";
import { MyProjectItem } from "../User/Profile/myProjectsItem";
import { LoadingCircle } from "../loading";
import { Typography, Box } from "@mui/material/node";

export const MyProjectsList = (props) => {

    const { data: projects, isLoading, isError } = useQuery({queryKey:["loadmyprojects"], queryFn: async () => {
        const q = query(collection(db, "project"), where("owner", "==", props.user.uid));
        const data = await getDocs(q)

        const filteredData = data.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id
        }));

        return filteredData;
    }});

    if (isLoading) return (<LoadingCircle/>)

    if (isError) return (
        <h1>Ou ... Can't load your projects :(</h1>
    )

    if (!isLoading && !isError && projects.length == 0) return (
        <Box
            sx={{
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                p: 3,
                textAlign: 'center',
                backgroundColor: '#fafafa',
                mt: 2
            }}
        >
            <Typography variant="h6" sx={{ mb: 1 }}>
                You have no projects yet
            </Typography>
            <Typography variant="body1">
                Start your first project by clicking the <b>New Project</b> button above.<br />
                <br />
            </Typography>
            <Typography variant="body1">
                If you need help, check out our <a href="https://nodecanvas.com/#faq" target="_blank" rel="noopener noreferrer">FAQ</a> or <a href="https://youtube.com/@nodecanvas" target="_blank" rel="noopener noreferrer">Youtube channel</a>.
            </Typography>
        </Box>
    )

    return (
        <List>
            {projects?.map((value) => (
                <MyProjectItem project={value} />
            ))}
        </List>
    );
};